export default "__VITE_ASSET__DYfbnOZf__"